module.exports = __webpack_public_path__ + "img/course_0014.837c729.webp";